module.exports = __webpack_public_path__ + "img/1535224438.e3f90f20.jpg";